import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Initialize i18n with Russian as the default language
i18n
  .use(initReactI18next)
  .init({
    resources: {
      ru: {
        translation: {
          // Add your translations here
        }
      }
    },
    lng: 'ru',
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
